"use client";

import React, { useState } from "react";
import ReactDOM from "react-dom";
import { motion, AnimatePresence } from "framer-motion";
import MegaMenu from "../navigation/mega-menu";
import siteData from "@/app/data/site-data";

interface PortfolioModalProps {
  open: boolean;
  modalType?: string;
  onClose: () => void;
  title?: string;
}

export default function PortfolioModal({
  open,
  onClose,
  modalType,
  title = "Clients",
}: PortfolioModalProps) {
  if (!open) return null;
  return ReactDOM.createPortal(
    <AnimatePresence>
      <MegaMenu
        isOpen={open}
        onClose={onClose}
        data={
          title === "Clients"
            ? siteData.caseStudyMegaMenu
            : siteData.servicesMegaMenu
        }
        title={title}
        modalType={modalType}
      />
    </AnimatePresence>,
    document.body
  );
}
